import {
  InputLabel as MuiInputLabel,
  InputLabelProps,
} from '@material-ui/core';
import React, { useEffect, useRef } from 'react';
import { useController } from 'react-hook-form';
import { useFieldControllerContext } from './FieldControllerContext';
import { fieldHasError } from './formUtils';

const FieldInputLabel: React.FC<InputLabelProps> = ({ children, ...props }) => {
  const { name, setInputLabel } = useFieldControllerContext();
  const { fieldState } = useController({ name });

  const ref = useRef<HTMLLabelElement | null>(null);

  useEffect(() => {
    const inputLabel =
      typeof children === 'string' ? children : ref.current?.innerText;

    setInputLabel(inputLabel);
  }, [children, setInputLabel]);

  return (
    <MuiInputLabel
      ref={ref}
      id={`${name}-label`}
      htmlFor={name}
      error={fieldHasError(fieldState)}
      {...props}
    >
      {children}
    </MuiInputLabel>
  );
};

export default FieldInputLabel;
